import type { MenuOption } from '@saviynt/design-system';

/** Operator key (stored) -> display label (shown in UI) */
export const OPERATOR_OPTIONS: MenuOption[] = [
  { value: 'eq', label: 'Is' },
  { value: 'neq', label: 'Is not' },
  { value: 'contains', label: 'Contains' },
  { value: 'not_contains', label: 'Does not contain' },
  { value: 'in', label: 'Is one of' },
  { value: 'not_in', label: 'Is not one of' },
  { value: 'exists', label: 'Is not empty' },
  { value: 'not_exists', label: 'Is empty' },
];

export function getOperatorLabel(key: string): string {
  return OPERATOR_OPTIONS.find((o) => o.value === key)?.label ?? key;
}

export interface ConditionRow {
  id: string;
  attribute: string;
  operator: string;
  value: string;
  selectedValues?: string[]; // For multi-select chip values
}

export interface OwnerRow {
  id: string;
  role: string;
  rank: string;
  owner: string;
  /** Cached display name so the selected owner label survives search changes */
  ownerLabel?: string;
  /** Cached email so the payload can send email instead of user ID */
  ownerEmail?: string;
}

export function createEmptyConditionRow(): ConditionRow {
  return {
    id: String(Date.now()),
    attribute: '',
    operator: 'eq',
    value: '',
  };
}

export function createEmptyOwnerRow(): OwnerRow {
  return {
    id: String(Date.now()),
    role: '',
    rank: '',
    owner: '',
  };
}

/** True if row has non-empty role, rank, and owner (for step 2 count and save validation) */
export function isOwnerRowValid(row: OwnerRow): boolean {
  return (
    (row.role ?? '').trim() !== '' &&
    (row.rank ?? '').trim() !== '' &&
    (row.owner ?? '').trim() !== ''
  );
}

export const DEFAULT_CONDITIONS: ConditionRow[] = [
  {
    id: '1',
    attribute: 'Agent.label.businessFunction',
    operator: 'eq',
    value: 'Finance',
  },
  {
    id: '2',
    attribute: 'Agent.label.country',
    operator: 'in',
    value: 'USA, India, Canada',
  },
];

/** Step 2 initial load: one row with Role=Business, Rank=1, Owner=unset (Select owner) */
export const DEFAULT_OWNERS: OwnerRow[] = [
  { id: '1', role: 'business', rank: '1', owner: '' },
];
